import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';

interface IProductDestockProps {
  product: IProduct;
}

const ProductDestock: React.FC<IProductDestockProps> = ({ product }) => {
  const tProducts = useTranslations('Products');

  const destock = product.meta.marketing?.destock_reason || '';

  if (!destock) return null;

  return (
    <>
      <h3 className="tw-lf-body-xbold-md tw-mt-5">{tProducts('destock')}</h3>
      <div
        className="tw-lf-rich-text tw-mt-2 tw-leading-normal"
        dangerouslySetInnerHTML={{
          __html: destock,
        }}
      />
    </>
  );
};

export default ProductDestock;
